// extracted by mini-css-extract-plugin
export default {"error":"styles_error__eVxe6","error-icon":"styles_error-icon__Gk6u9","error-text":"styles_error-text__AVe8r"};